import React from 'react';
import { PageHeader } from '../../components/PageHeader';
import { AlertBlock } from '../../components/AlertBlock';

export function OrganizationPage() {
  return (
    <>
      <div className="row">
        <div className="col-md-10">
          <PageHeader icon="fas fa-building" title="Organizations" />
        </div>
      </div>

      <div className="row">
        <div className="col-md-10">
          <AlertBlock type="warning" heading="Organizations coming soon!" />
          <AlertBlock type="info" heading="You aren't a part of an organization yet">
            <p>To be added to an existing organization, you need to be invited by one of the organization admins.</p>
          </AlertBlock>
        </div>
      </div>
    </>
  );
}
